import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Twitter, Linkedin, Instagram, Youtube } from 'lucide-react';
import { COLORS } from '../data/mockData';

const SOCIAL = [
  { icon: Twitter, label: 'Twitter' },
  { icon: Linkedin, label: 'LinkedIn' },
  { icon: Instagram, label: 'Instagram' },
  { icon: Youtube, label: 'YouTube' },
];

const PLATFORM = [
  { l: 'Features', h: '/' },
  { l: 'Pricing', h: '/' },
  { l: 'Research', h: '/research' },
  { l: 'Blog', h: '/blog' },
  { l: 'Get the App', h: '/' },
];

const COMPANY = [
  { l: 'About Us', h: '/about' },
  { l: 'Careers', h: '/info' },
  { l: 'Contact', h: '/info' },
  { l: 'Partners', h: '/about' },
  { l: 'Investors', h: '/info' },
  { l: 'Referrals', h: '/info' },
];

const LEGAL = [
  { l: 'Terms of Use', h: '/terms' },
  { l: 'Privacy Policy', h: '/terms' },
  { l: 'Accessibility', h: '/terms' },
  { l: 'HIPAA Compliance', h: '/terms' },
  { l: 'Sitemap', h: '/' },
];

export default function SiteFooter() {
  return (
    <footer style={{ backgroundColor: COLORS.textPrimary, paddingTop: 48, paddingBottom: 0 }}>
      <div style={{ maxWidth: 1140, margin: '0 auto', padding: '0 20px', display: 'flex', gap: 32, flexWrap: 'wrap' }}>
        <div style={{ flex: '2 1 280px', minWidth: 220 }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', marginBottom: 8 }}>
            <Leaf size={22} color={COLORS.primary} />
            <span style={{ fontSize: 20, fontWeight: 800, color: '#FFF', letterSpacing: -0.5, fontFamily: 'Outfit, sans-serif' }}>ThriveLonger.ai</span>
            <img src="/thrivelonger-logo.png" alt="ThriveLonger logo" data-testid="brand-logo-footer" style={{ height: 30, width: 'auto', display: 'block', filter: 'brightness(1.15)' }} />
          </Link>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.5, marginTop: 8, maxWidth: 340 }}>
            Evidence-based health optimization powered by AI. Modeled after NIA, Stanford Longevity Center, and Lifespan.io research.
          </p>
          <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
            {SOCIAL.map(({ icon: Icon, label }) => (
              <button key={label} style={{ width: 36, height: 36, borderRadius: 18, backgroundColor: 'rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer', transition: 'background-color 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
              >
                <Icon size={18} color="rgba(255,255,255,0.7)" />
              </button>
            ))}
          </div>
        </div>

        <FooterCol title="Platform" items={PLATFORM} />
        <FooterCol title="Company" items={COMPANY} />
        <FooterCol title="Legal" items={LEGAL} />
      </div>

      <div style={{ maxWidth: 1140, margin: '0 auto', borderTop: '1px solid rgba(255,255,255,0.1)', padding: '20px 20px', marginTop: 32 }}>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', textAlign: 'center', margin: 0 }}>
          &copy; 2026 ThriveLonger.ai. All Rights Reserved. HIPAA Compliant.
        </p>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div style={{ flex: '1 1 150px', minWidth: 130 }}>
      <h4 style={{ fontSize: 14, fontWeight: 700, color: '#FFF', marginBottom: 16, fontFamily: 'Outfit, sans-serif' }}>{title}</h4>
      {items.map(i => (
        <Link key={i.l} to={i.h} style={{ display: 'block', fontSize: 14, color: 'rgba(255,255,255,0.7)', padding: '3px 0', textDecoration: 'none', transition: 'color 0.2s' }}
          onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,1)'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
        >{i.l}</Link>
      ))}
    </div>
  );
}
